import { isMobile } from './../../../../helper-functions'

/**
 * Function that creates timeline slider and manages margin.
 */
export default function timelineSlider () {

  Array.from( document.querySelectorAll( '.js-timeline' ) ).forEach(
    timeline => main( timeline )
  )

  window.timelines = window.timelines || []

  /**
   * Inits each timeline instance.
   *
   * @param {object} timeline A timeline instance.
   */
  function main( timeline ) {
    const slider = new window.Flickity( timeline, {
      initialIndex: isMobile() ? '0' : '1',
      percentPosition: true,
      prevNextButtons: true,
      autoPlay: false,
      pageDots: false,
      accessibility: true,
      draggable: true
    })

    // Add prev/next labels.
    const prevlbl = timeline.dataset.prevLabel
    const nextlbl = timeline.dataset.nextLabel
    timeline.querySelector( '.previous' ).innerHTML = ( prevlbl ) ? prevlbl : ''
    timeline.querySelector( '.next' ).innerHTML = ( nextlbl ) ? nextlbl : ''

    window.timelines = slider
  }
}
